module.exports = __webpack_public_path__ + "img/news10-0.df1cffe5.png";